<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Titel 1" more="/foobar" :help="help1" :secondline="secondline1" color="#07D3DA">{{ value1 | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Titel 2" more="/foobar" :help="help2" :secondline="$options.filters.toInt(secondline2, 0, 'ETH')" color="#C6362F">{{ value2 | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Titel 3" more="/foobar" :help="help3" color="#BDD358">{{ value3 | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Titel 4"  more="/foobar" :help="help4" color="#E28413">{{ value4 | toInt(0, "WISE")}}</NumberCard>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12">
        foobar
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NumberCard from "@/components/widgets/NumberCard.vue";

  import {
    mapState
  } from 'vuex';

  export default {
    name: "Staking",
    components: {
      NumberCard
    },
    data() {
      return {
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        secondline1: 0,
        secondline2: 0,
        help1: "Uniswap liquidity not included",
        help2: "",
        help3: "",
        help4: "",
      }
    },
    computed: {
      ...mapState({
        currentWiseDay: state => state.currentWiseDay,
      }),
    },
    mounted() {
      this.updateAllCards();
    },
    methods: {
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          this.value1 = 0;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          this.value2 = 0;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.value3 = 0;
        }
      },
      updateCard4() {
        if (this.isDataFetchedCard4()) {
          this.value4 = 0;
        }
      },
    },
    watch: {
      currenctWiseDay() {
        this.updateCard1();
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
